import axios from 'axios';
import { apiCallOperations } from 'Redux/ducks/apiCall';

const { get, post } = axios;
const urlPrefix = process.env.NODE_ENV !== 'production' ? '' : 'https://contract-generator.viato.travel';

export function getApiCallAction(url, TYPE, options, postProcessor, actionOnError) {
	return dispatch => {
		dispatch(apiCallOperations.setApiCallPendingStatus(TYPE.REGULAR, true, undefined));
		get(urlPrefix + url, options)
			.then(response => {
				if (response.error) {
					throw response.error;
				}
				if (response.data.error) {
					throw response.data.error;
				}
				if (response.status === 200) {
					dispatch({
						type: TYPE.SUCCESS,
						payload: typeof postProcessor === 'function' ? postProcessor(response.data) : response.data
					});
					dispatch(apiCallOperations.setApiCallPendingStatus(TYPE.REGULAR, false, false));
				} else {
					throw response;
				}
			})
			.catch(error => {
				if (typeof actionOnError !== 'undefined') {
					dispatch(actionOnError);
				}
				dispatch(apiCallOperations.setApiCallError(TYPE.REGULAR, error));
			});
	};
}

export function postApiCallAction(url, TYPE, data, actionOnSuccess, options, actionOnError) {
	return dispatch => {
		dispatch(apiCallOperations.setApiCallPendingStatus(TYPE.REGULAR, true, undefined));
		post(urlPrefix + url, data, options)
			.then(response => {
				if (response.error) {
					throw response.error;
				}
				if (response.data.error) {
					throw response.data.error;
				}
				if (response.status === 200) {
					dispatch({
						type: TYPE.SUCCESS,
						payload: response.data
					});
					if (typeof actionOnSuccess !== 'undefined') {
						actionOnSuccess(response.data);
					}
					dispatch(apiCallOperations.setApiCallPendingStatus(TYPE.REGULAR, false, false));
				} else {
					throw response;
				}
			})
			.catch(error => {
				if (typeof actionOnError !== 'undefined') {
					dispatch(actionOnError);
				}
				dispatch(apiCallOperations.setApiCallError(TYPE.REGULAR, error));
			});
	};
}
